import { BenefitTypes } from '@strata/constants';

import { useGetNeedsByDateQuery } from 'store/api/performanceApi';
import { useGetTreatmentDetailsQuery } from 'store/api/treatmentApi';

export const useNeedsByDate = ({ treatmentId, referralId, payerId }) => {
    const { data: treatmentDetails } = useGetTreatmentDetailsQuery(
        { treatmentId, payerId },
        {
            skip: !(treatmentId && payerId),
        },
    );
    const showNeedsByDate =
        treatmentDetails?.isActive && // only show needs by date if treatment is active
        // and active referral is this referral
        treatmentDetails?.activeReferral?.referralId === referralId &&
        // and this referral is a pharmacy referral
        treatmentDetails?.activeReferral?.benefitTypeRaw === BenefitTypes.PHARMACY;
    const { data: needsByDateData } = useGetNeedsByDateQuery(
        { treatmentId },
        {
            skip: !showNeedsByDate,
        },
    );

    return { showNeedsByDate, needsByDateData };
};
